import { action, observable } from 'mobx';
import ILogTableStore from 'shared/containers/MobXLogTable/ITableStore';
import HistoryMenuUsageStatusModel from 'shared/models/history/HistoryMenuUsageStatusModel';
import HistoryMenuUsageStatusSearchModel from 'shared/models/history/HistoryMenuUsageStatusSearchModel';
import { RootStore } from 'shared/stores/RootStore';
import HistoryService from 'shared/services/HistoryService';
import uuid from 'uuid';
import AppConst from 'shared/utils/AppConst';
import AppHelper from 'shared/utils/AppHelper';

export class HistoryMenuUsageStatusStore implements ILogTableStore<HistoryMenuUsageStatusModel> {
  @observable
  inProgress: boolean;

  rootStore: RootStore;
  @observable
  searchModel: HistoryMenuUsageStatusSearchModel;

  @observable
  dataSource: HistoryMenuUsageStatusModel[];

  /** Actual number of records in DB */
  @observable
  totalCount: number;

  constructor(rootStore: any) {
    this.rootStore = rootStore;
    this.resetStore();
  }

  @action
  export = async () => {
    try {
      const params = this.parseSearchModelToApiParams();
      const response = await HistoryService.exportMenuUsageStatusHistories(params);
      this.rootStore.apiHandleStore.handleApiExport(response);
    } catch (error) {
      this.rootStore.apiHandleStore.handleApiError(error);
    }
  };

  @action
  find = async () => {
    try {
      this.inProgress = true;
      this.dataSource = Array<HistoryMenuUsageStatusModel>();
      const histories = Array<HistoryMenuUsageStatusModel>();
      const params = this.parseSearchModelToApiParams();
      const response = await HistoryService.findMenuUsageStatusHistories(params);
      const { isSuccessful } = response.data.header;
      if (!isSuccessful) {
        this.inProgress = false;
        this.rootStore.apiHandleStore.handleApiFail(response.data.header);
        return;
      }

      const { empty, totalCount, results } = response.data.data;
      const data = results || [];
      const length = data ? data.length : 0;
      for (let index = 0; index < length; index++) {
        const element = data[index];
        element.no = index + 1;
        element.id = uuid.v4();
        element.changeStatus = AppConst.ActionType.READ;
        histories.push(element);
      }
      this.totalCount = totalCount || 0;
      this.dataSource = histories;
      this.inProgress = false;
    } catch (error) {
      this.inProgress = false;
      this.rootStore.apiHandleStore.handleApiError(error);
    }
  };

  @action
  setDataSource(dataSource: HistoryMenuUsageStatusModel[]) {
    this.dataSource = dataSource;
  }

  getDataSource() {
    return this.dataSource;
  }

  /**
   * @Override
   */
  resetSearchModel() {
    this.searchModel = {
      useYn: '',
      menuName: '',
      offset: AppConst.LOG_DEFAULT_OFFSET,
      limit: AppConst.LOG_TABLE_PAGE_SIZE,
      usedDateFrom: 0,
      usedDateTo: 0
    };
  }

  parseSearchModelToApiParams = () => {
    const { usedDateFrom, usedDateTo, useYn, menuName, offset } = this.searchModel;
    return {
      usedDateFrom: this.trimDate(usedDateFrom),
      usedDateTo: this.trimDate(usedDateTo),
      useYn,
      menuName,
      offset,
      limit: AppConst.LOG_TABLE_PAGE_SIZE
    };
  };

  /**
   * @Override
   */
  @action
  resetStore = () => {
    this.totalCount = 0;
    this.setDataSource(Array<HistoryMenuUsageStatusModel>());
    this.resetSearchModel();
  };

  trimDate = (dateValue: number) => {
    return dateValue > 0 ? dateValue : '';
  };
}
